<template>
    <div class="land-main" v-if="salesCard != null">
        <div class="section-title-mobile" v-if="isMobileChecker">
            <div class="pic-title-bg" :style="'background-image: url(' + salesCard.prems_section_title_img + ')'"></div>
            <!-- <h2>{{salesCard.prems_section_title}}</h2> -->
            <h2 v-html="salesCard.prems_section_title"></h2>
        </div>
        <div class="container">
            <div class="land-main-items" :class="'land-main-items-' + projectNameG">
                <div class="item" v-for="(item, index) in salesCard.prems_icon_list" :key="index">
                    <div class="item-img">
                        <img :src="item.icon" alt="">
                    </div>
                    <div class="item-info">
                        <p v-html="item.desc"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-land-main',
        components: {
        },
        data () {
            return {
                projectNameG: window.host,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-main.scss';
    @import '@/styles/components/sales/respond/land-main-respond.scss';
</style>